import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';

import { ChatPanelService } from '../../../layout/components/chat-panel/chat-panel.service';
import { CrudEmployeeService } from '../../../gt2/content/crud/crud-employee/crud-employee.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';

@Component({
  selector: 'chat-panel',
  templateUrl: './chat-panel.component.html',
  styleUrls: ['./chat-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [ChatPanelService],
  imports: [MatTooltipModule, CommonModule, FuseDirectivesModule],
})
export class ChatPanelComponent implements OnInit, OnDestroy {
  contacts?: any[];

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {ChatPanelService} _chatPanelService
   */
  constructor(
    private _chatPanelService: ChatPanelService,
    private _crudEmployeeService: CrudEmployeeService,
    private _router: Router,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  /**
   * Clic sur un avatar : ouvre la page LiveChat sur la conversation directe
   * (DM) avec cet utilisateur. Cliquer sur son propre avatar (ou un employé
   * sans compte user) ouvre simplement la page chat.
   */
  onContactClick(contact: any): void {
    const prefix = localStorage.getItem('PREFIX') || '';
    const myUserUuid = this._crudEmployeeService.me?.user?.uuid;
    const dm =
      contact?.userUuid && contact.userUuid !== myUserUuid
        ? contact.userUuid
        : null;
    this._router.navigate([prefix + '/chat'], {
      queryParams: dm ? { dm } : {},
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Load the contacts (real employees/users)
    this._chatPanelService.loadContacts().then(() => {
      this.contacts = this._chatPanelService.contacts;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
